import React from "react";
import PropTypes from "prop-types";
import DispatchItem from "../DispatchItem/index";
import { SortableContainer, SortableElement } from "react-sortable-hoc";
import DispatchAdd from "../Buttons/DispatchAddButton";
import isMobile from "../../Helpers/is-mobile";
import MainModal from "../Modals/MainModal";

const DispatchList = ({
  teams,
  handleReorderDispatch,
  onAddClick,
  userType
}) => {
  const renderedTeams = sortedTeamsByIndex();

  const handleMove = event => {
    if (!isMobile.any()) {
      if (window.innerHeight - event.clientY < 50) {
        window.scrollBy(0, 20);
      } else if (event.clientY < 50) {
        window.scrollBy(0, -20);
      }
    }
  };

  function sortedTeamsByIndex() {
    return teams.sort((a, b) => a.index - b.index);
  }

  const SortableItem = SortableElement(({ value }) => (
    <DispatchItem team={value} />
  ));

  const SortableList = SortableContainer(({ items }) => {
    return (
      <ul>
        {items.map((team, index) => (
          <SortableItem key={team.id} index={team.index} value={team} />
        ))}
        {userType === "admin" && <DispatchAdd onClick={onAddClick} />}
      </ul>
    );
  });

  const onSortEnd = ({ oldIndex, newIndex }) => {
    if (oldIndex !== newIndex) {
      const team = teams.find(t => t.index === oldIndex);
      if (team) {
        handleReorderDispatch(team.id, oldIndex, newIndex);
      }
    }
  };

  const shouldCancelStart = e => {
    return e.target.classList[0] !== "content-box-header";
  };

  function getDispatchLines() {
    if (userType !== "admin") {
      return teams.map(team => {
        return <DispatchItem key={`t-${team.id}`} team={team} />;
      });
    }
    return (
      <SortableList
        axis={"xy"}
        items={renderedTeams}
        onSortEnd={onSortEnd}
        shouldCancelStart={shouldCancelStart}
        onSortMove={handleMove}
      />
    );
  }

  // consultDispatch
  const className =
    userType === "admin"
      ? "dispatch-class connectedSortable"
      : `dispatch-class consultDispatch ${userType}`;
  return (
    <div className={className} style={{ margin: "auto" }}>
      {getDispatchLines()}
      <MainModal />
    </div>
  );
};

DispatchList.propTypes = {
  teams: PropTypes.array,
  handleReorderDispatch: PropTypes.func,
  onAddClick: PropTypes.func
};

export default DispatchList;
